import { render, staticRenderFns } from "./CreateRateTableModal.vue?vue&type=template&id=2253399d&"
import script from "./CreateRateTableModal.vue?vue&type=script&lang=ts&"
export * from "./CreateRateTableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports